const labels = {
  pageHeading: 'ابحث عن ناديك الرياضي',
  search: 'بحث',
  location: 'البحث عن طريق المدينة أو البلدة أو الرمز البريدي',
  joinLink: 'انضم الآن',
  gymLink: 'مزيد من المعلومات',
  costBreakdown: 'من {currentPrice} شهريا',
  currentLocation: 'ابحث عن نادٍ قريب',
  successSearchMapHint: 'اضغط على رموز التثبيت لإيجاد معلومات إضافية عن كل نادٍ.',
  backToAllGyms: 'الرجوع لكل الأندية',
  miles: {
    zero: '{distance} ميل',
    one: '{distance} ميل',
    two: '{distance} ميل',
    few: '{distance} ميل',
    many: '{distance} ميل',
    other: '{distance} اميال'
  },
  kilometers: {
    zero: '{distance} كيلومتر',
    one: '{distance} كيلومتر',
    two: '{distance} كيلومتر',
    few: '{distance} كيلومتر',
    many: '{distance} كيلومتر',
    other: '{distance} كيلومترات'
  },
  mapView: 'عرض الخريطة',
  mapViewTitle: 'عرض الأندية على الخريطة',
  listView: 'عرض قائمة',
  listViewTitle: 'عرض الأندية في قائمة',
  gymsList: 'قائمة الأندية في منطقة بحثك',
  resetGymSearch: 'إعادة تعيين الأندية',
  mapSearchLocationTooltip: 'عرض المسافة من هنا',
  loadingMapGyms: 'تحميل أندية',
  gymDisplayToggle: 'تبديل بين عرض قائمة وعرض خريطة',
  mapEnterFullScreen: 'توسيع الخريطة على ملء الشاشة',
  mapExitFullScreen: 'إنهاء عرض ملء شاشة الخريطة',
  infoModalTriggerText: 'مزيد من المعلومات',
  infoModalHeading: '{brandName} - ابحث عن ناديك الرياضي',
  classesSectionTitle: 'الفئات المدرجة في عضويتك',
  membershipOptionsSectionTitle: 'خيارات العضوية',
  managersSectionTitle: 'قابل المديرين',
  findUsSectionTitle: 'كيف تجد',
  noContract: 'لا يوجد عقد ملزم مع النادي - غادر في أي وقت',
  overview: 'ملخص',
  personalTrainers: 'مدربين شخصيين',
  classTimetable: 'الجدول الزمني للحصص',
  welcomeSectionTitle: 'أهلا بك في بيور جيم! {gymName}',
  upgradeLink: 'رفع مستوى',
  membershipOptionsLink: 'خيارات العضوية',
  gyms: 'صالاترياضية',
  classes: 'الحصص التدريبية',
  viewMap: 'إعرض الخريطة',
  moreInformationTitle: 'معلومات اكثر',
  searchResults: 'نتائج البحث',
  ok: 'نعم',
  noGymsFoundNearby: 'لم يتم العثور على أندية قريبة، اعرض جميع الأندية الرياضية. انقر على الخريطة لمزيد من المعلومات.',
  nearbyGyms: 'النوادي الرياضية المجاورة',
  viewAllGyms: 'عرض كل النوادي الرياضية',
  address: 'العنوان',
  contactUs: 'اتصل بنا',
  messenger: 'مسنجر',
  twitter: 'تويتر',
  telephone: 'الهاتف',
  email: 'البريد الالكتروني',
  emailThisGym: 'راسل خدمة اعضاء هذا النادي',
  twitterDm: 'رسالة خاص على التويتر',
  directions: 'الاتجاهات',
  instagram: 'إنستغرام',
  gymsFoundNearby: {
    zero: 'تم العثور على {resultCount} صالة ألعاب رياضية في مكان قريب منك. انقر على دبابيس الخريطة لمزيد من المعلومات.',
    one: 'تم العثور على {resultCount} صالة ألعاب رياضية في مكان قريب. انقر على دبابيس الخريطة لمزيد من المعلومات.',
    two: 'تم العثور على {resultCount} صالة ألعاب رياضية في مكان قريب. انقر على دبابيس الخريطة لمزيد من المعلومات.',
    few: 'تم العثور على {resultCount} صالة ألعاب رياضية في مكان قريب. انقر على دبابيس الخريطة لمزيد من المعلومات.',
    many: 'تم العثور على {resultCount} صالة ألعاب رياضية في مكان قريب. انقر على دبابيس الخريطة لمزيد من المعلومات.',
    other: 'تم العثور على {resultCount} صالة ألعاب رياضية في مكان قريب. انقر على دبابيس الخريطة لمزيد من المعلومات.'
  },
  searchCount: {
    zero: '{resultCount} صالة ألعاب رياضية',
    one: '{resultCount} صالة ألعاب رياضية',
    two: '{resultCount} صالة ألعاب رياضية',
    few: '{resultCount} صالة ألعاب رياضية',
    many: '{resultCount} صالة ألعاب رياضية',
    other: '{resultCount} صالة ألعاب رياضية'
  },
  personalTrainersUrlRoute: 'مدربين شخصيين',
  classesUrlRoute: 'الحصص التدريبية',
  overviewUrlRoute: 'ملخص',
  gymReviews: 'استعراض الصالة الرياضية',
  personalTrainersComingSoon: 'سيكون المدربون الشخصيون متاحين عند افتتاح الصالة.\n\nاكتشف المزيد حول التدريب الشخصي في بيور جيم أدناه.',
  classesComingSoon: 'عندما تفتتح الصالة التي اخترتها، سيكون جدول الحصص التدريبية متاحًا هنا.\n\nأثناء انتظارك للأفتتاح القريب باذن الله، ألق نظرة على مجموعتنا الواسعة من الحصص التدريبية التي سوف تكون متاحة لك!',
  findOutMore: 'اكتشف المزيد',
  gymDocumentationHeading: 'توثيق الصالة الرياضية',
  documentName: 'معلومات الإخلاء',
  joinUrlSegment: 'انضم',
  membersUrlSegment: 'أفراد',
  bookAClassUrlSegment: 'كتاب-من-الدرجة-الأولى',
  gymsUrlSegment: 'صالات-رياضية',
  personalTrainersHelpText: 'حدد مدربًا شخصيًا لمعرفة المزيد عنه',
  threeSixtyTour: 'قم بجولة 360 درجة',
  open24Hours: '24 ساعة / يوم ، 7 أيام في الأسبوع',
  openingHours: 'ساعات العمل',
  unstaffedHours: 'عرض خارج ساعات عمل فريق النادي',
  unstaffedHoursHeading: 'الساعات خارج ساعلت عمل فريق النادي',
  unstaffedHoursCloseLabel: 'إغلاق الساعات غير المزودة بالموظفين',
  openingHoursWeekday: 'أيام الأسبوع',
  openingHoursTimeRanges: 'ساعات العمل',
  unstaffedHoursTimeRanges: 'الساعات خارج ساعلت عمل فريق النادي',
  unstaffedHoursWeekday: 'أيام الأسبوع',
  personalTrainersList: 'List of personal trainers available at this gym',
  findYourFavouriteClasses: 'ابحث عن الفصول الدراسية المفضلة لديك',
  managersHelpText: 'في PureGym ، فريقك موجود دائمًا لمساعدتك. لدينا أيضا مدربين شخصيين في متناول اليد.',
  findYourPersonalTrainer: 'ابحث عن مدربك الشخصي',
  gymManager: 'مدير صالة الألعاب الرياضية',
  assistantManager: 'مساعد مدير صالة الألعاب الرياضية',
  breadcrumbs: {
    home: 'Home',
    city: 'Gyms in {cityName}'
  },
  lowPrices: 'low prices',
  classesMetaTitle: 'Fitness, Yoga & Zumba Classes in {GymName}',
  classesMetaDescription: 'Enjoy getting fit with others and join PureGym {GymName} for just {LowestPrice}, we\'ve got a huge range of fitness classes to suit all needs!',
  personalTrainersMetaTitle: 'Personal Trainers in {GymName}',
  personalTrainersMetaDescription: 'At PureGym {GymName}, our personal trainers can offer sessions and classes to help you reach your fitness goals for just {LowestPrice}. Join now!',
  gymComingSoon: 'PureGym {gymName} is coming soon',
  checkSoonForUpdates: 'Check back soon for updates and offers! When the gym has an opening date you’ll be able to sign up here.',
  status: {
    blocked: 'مغلق',
    comingSoon: 'الافتتاح قريبا',
    paused: 'مغلق مؤقتا',
    preJoin: 'الافتتاح قريبا',
    open: 'فتح',
    reopeningSoon: 'إعادة الافتتاح قريبا'
  },
  errors: {
    genericApiError: 'لم نتمكن من إيجاد موقعك',
    noGyms: 'عذرا، لا يوجد أندية تطابق بحثك'
  },
  gymCard: {
    specialOffer: 'عرض خاص',
    openingOffer: 'العرض الافتتاحي',
    costBreakdown: 'من {currentPrice} شهريا',
    discountedCostBreakdown: {
      zero: 'لشهرك الأول + {joiningFee} رسوم اشتراك',
      one: 'لشهرك الأول + {joiningFee} رسوم الانضمام',
      two: 'لأول {discountPeriod} أشهر + {joiningFee} رسوم انضمام',
      few: 'لأول {discountPeriod} أشهر + {joiningFee} رسوم انضمام',
      many: 'لأول {discountPeriod} أشهر + {joiningFee} رسوم انضمام',
      other: 'لأول {discountPeriod} أشهر + {joiningFee} رسوم انضمام'
    },
    offerCostBreakdown: '{normalPrice} {currentPrice} شهريا'
  },
  timetable: {
    sectionHeading: 'الحصص التدريبية ',
    selectors: {
      weekView: 'عرض الأسبوع',
      listView: 'عرض القائمة',
      viewModeLabel: 'عرض التقويم الجدولي',
      previousWeek: 'الأسبوع الماضي',
      nextWeek: 'الاسبوع المقبل'
    },
    classType: {
      buttonLabel: 'اعرض لي',
      all: 'جميع الحصص التدريبية',
      induction: 'الحصص التعريفية فقط',
      class: 'الحصص التدريبية فقط',
      digital: 'الحصص الرقمية فقط',
      typeGroupLabel: 'أنواع الحصص التدريبية',
      nameGroupLabel: 'الحصص المتاحة'
    },
    classDetails: {
      digitalType: 'الحصص الرقمية',
      inductionType: 'حصة تعريفية',
      classDuration: '({duration} دقيقة)',
      classCapacity: {
        zero: '{capacity} spaces',
        one: '{capacity} space left',
        two: '{capacity} spaces',
        few: '{capacity} spaces',
        many: '{capacity} spaces',
        other: '{capacity} spaces'
      },
      classNotAvailable: 'غير متوفر',
      noAvailableClasses: 'لا توجد حصص تدريبية متاحة للحجز في هذا اليوم'
    },
    timeRange: {
      buttonLabel: 'الوقت من اليوم',
      allDay: 'طوال اليوم',
      morning: 'الصباح (00:00 صباحا - 09:00 صباحا)',
      noon: 'ظهرًا (09:00 ص - 12:00 م)',
      afternoon: 'بعد الظهر (12:00 مساءً - 05:00 مساءً)',
      evening: 'مساءً (05:00 مساءً - 11:59 مساءً)'
    },
    calendar: {
      today: 'اليوم',
      tomorrow: 'الغد',
      classTitle: 'الحصة التدريبية',
      duration: 'المدة  (Duration)',
      studio: 'ستوديو',
      instructor: 'مدرب',
      info: 'معلومات عن الحصة التدريبية'
    },
    classModal: {
      duration: 'المدة',
      timeDate: 'الوقت والتاريخ',
      studio: 'ستوديو',
      instructor: 'المدرب(ة)',
      energy: 'سعرات حرارية',
      capacity: 'المساحات',
      energyValue: 'متوrع حرق {energyConsumption} سعرة حرارية',
      durationValue: '{duration} دقيقة',
      buttonModal: 'عرض تفاصيل الحصة التدريبية',
      bookingsUrl: 'إدارة حجوزاتك'
    },
    introductionText: 'سواء كنت ترغب في حرق السعرات الحرارية أو مجرد الحصول على لياقة بدنية عالية والاستمتاع، لدينا حصص تدريبية لجميع أهدافك، ومناسبة لجميع القدرات! هناك مجموعة كبيرة من الحصص التدريبية كل أسبوع مدرجة في عضويتك - ما عليك سوى تسجيل الدخول والحجز على الموقع الإلكتروني ، أو عبر تطبيق بيور جيم المجاني',
    noAvailableClasses: 'عذرا ، الحصص التدريبية غير متوفرة مؤقتًا على الموقع. في الوقت الحالي ، يرجى زيارة صالة الألعاب الرياضية شخصيًا لاختيار بين الحصص التدريبية و حجزها.',
    introductionInfo: 'المعلومات عن الحصص التدريبية الموضحة هنا هي فقط ممثلة لآخر تحديث وقد تختلف. للوصول إلى معلومات الحجز الحية بما في ذلك توفر الحصة التدريبية والتفاصيل عن المدرب، يرجى تسجيل الدخول.'
  },
  gymBanner: {
    anchorTitle: '{gymName} انضم'
  },
  reviews: {
    scoreLabel: '{value} out of 5 star rating on Trustpilot',
    totalReviewCount: {
      zero: 'Based on {reviewCount} reviews',
      one: 'Based on {reviewCount} review',
      two: 'Based on {reviewCount} reviews',
      few: 'Based on {reviewCount} reviews',
      many: 'Based on {reviewCount} reviews',
      other: 'Based on {reviewCount} reviews'
    },
    widgetLabel: 'Trustpilot reviews',
    logo: 'Trustpilot',
    explanation: 'Showing our latest reviews',
    pageTitle: '{gym} gym reviews'
  },
  hero: {
    personalTrainersHeading: 'Personal trainers at {gymHeading}',
    classesHeading: 'Fitness classes at {gymHeading}'
  },
  cityPages: {
    indexPageHeading: 'Find your nearest gym',
    cityPageHeading: 'Gyms in {cityName}',
    buttonGyms: 'View gyms',
    buttonJoin: 'Join now',
    signoffText: 'Close to work or home, we\'ve got you covered',
    featuresHeading: 'What makes our gyms great?',
    featuresListLabel: 'List of features'
  },
  gymFinder: {
    heading: 'ابحث عن ناديك الرياضي',
    search: 'بحث',
    currentLocation: 'ابحث عن نادٍ قريب',
    location: 'البحث عن طريق المدينة أو البلدة أو الرمز البريدي',
    mapSearchLocationTooltip: 'عرض المسافة من هنا',
    backToAllGyms: 'الرجوع لكل الأندية',
    successSearchMapHint: 'اضغط على رموز التثبيت لإيجاد معلومات إضافية عن كل نادٍ.',
    resetGymSearch: 'إعادة تعيين الأندية',
    searchResults: 'نتائج البحث',
    searchCount: {
      zero: '{resultCount} صالة ألعاب رياضية',
      one: '{resultCount} صالة ألعاب رياضية',
      two: '{resultCount} صالة ألعاب رياضية',
      few: '{resultCount} صالة ألعاب رياضية',
      many: '{resultCount} صالة ألعاب رياضية',
      other: '{resultCount} صالة ألعاب رياضية'
    },
    noGymsFoundNearby: 'لم يتم العثور على أندية قريبة، اعرض جميع الأندية الرياضية. انقر على الخريطة لمزيد من المعلومات.',
    gymsFoundNearby: {
      zero: 'تم العثور على {resultCount} صالة ألعاب رياضية في مكان قريب منك. انقر على دبابيس الخريطة لمزيد من المعلومات.',
      one: 'تم العثور على {resultCount} صالة ألعاب رياضية في مكان قريب. انقر على دبابيس الخريطة لمزيد من المعلومات.',
      two: 'تم العثور على {resultCount} صالة ألعاب رياضية في مكان قريب. انقر على دبابيس الخريطة لمزيد من المعلومات.',
      few: 'تم العثور على {resultCount} صالة ألعاب رياضية في مكان قريب. انقر على دبابيس الخريطة لمزيد من المعلومات.',
      many: 'تم العثور على {resultCount} صالة ألعاب رياضية في مكان قريب. انقر على دبابيس الخريطة لمزيد من المعلومات.',
      other: 'تم العثور على {resultCount} صالة ألعاب رياضية في مكان قريب. انقر على دبابيس الخريطة لمزيد من المعلومات.'
    },
    gymsNationwide: 'Choose from over {joinableGyms} gyms nationwide',
    searchSupportText: 'You\'ll find everything you need to know about your local gym, including what\'s inside, how to find us, parking information and more.'
  },
  citiesList: {
    gymsNearLink: 'Gyms near {cityName}',
    gymsInLink: 'Gyms in {cityName}',
    gymsNearText: {
      zero: '',
      one: '{joinableGyms} gym near {cityName} to choose from',
      two: '',
      few: '',
      many: '',
      other: '{joinableGyms} gyms near {cityName} to choose from'
    },
    gymsInText: {
      zero: '',
      one: '{joinableGyms} gym in {cityName} to choose from',
      two: '',
      few: '',
      many: '',
      other: '{joinableGyms} gyms in {cityName} to choose from'
    },
    label: 'List of cities'
  },
  shared: {
    core: {
      cookieBannerMessage: 'باستخدامك لهذا الموقع فأنت توافق على استخدامنا لملفات تعريف الارتباط.',
      menuButton: 'القائمة',
      closeMenuButton: 'إغلاق',
      logInButton: 'تسجيل دخول',
      logOutButton: 'تسجيل خروج',
      cookieBannerMoreLink: 'اعرف المزيد',
      menuTitle: 'افتح التنقل الأساسي',
      closeMenuTitle: 'أغلق التنقل الأساسي',
      menuBackText: 'الرجوع للسابق',
      languageSelectorTitle: 'تغيير اللغة',
      menuLabel: 'التنقل الأساسي',
      loading: 'جارٍ التحميل…',
      skipToMainContent: 'تخطي إلى المحتوى الرئيسي',
      home: 'الرئيسية',
      modalClose: 'أغلق هذا المشروط',
      iFrameNotSupported: 'مستعرضك لا يدعم الصفحات الداخلية',
      cookieConsentModify: 'تفضيلات ملفات تعريف الإرتباط',
      general: 'واجهنا مشكلة بسيطة وذلك مؤقت طبعا',
      languageSelectorText: 'اللغة',
      userMenuText: 'افتح قائمة المستخدم',
      unsupportedBrowserText: 'المتصفح الذي تستخدمه غير مدعوم',
      unsupportedBrowserLinkText: '',
      next: 'التالي',
      previous: 'سابق',
      regionSwitcherLabel: 'اختر دولة أخرى من قائمة الدول لعرض المحتوى الخاص بموقعك',
      continue: 'المتابعة',
      view: 'View',
      seeAll: 'See all',
      learnMore: 'Learn more',
      search: 'بحث',
      termsAndConditions: 'See T&Cs for details'
    }
  },
  joinMonthlyPackages: {
    packageTableCaption: 'اختر باقة النادي',
    packageTableLabel: 'اختر باقة النادي',
    offPeakDescription: 'ساعات دخول محدودة',
    standardDescription: 'عضويتنا الأساسية',
    premiumDescription: 'الخيار المفضل للعضوية',
    ribbonText: 'عرض خاص',
    button: 'تحديد',
    buttonSelected: 'المحدد',
    buttonLink: 'انضم',
    normalCostBreakdown: 'شهريًا + رسوم الانضمام {joiningFee}',
    discountedCostBreakdowns: {
      zero: 'عن الشهر الأول + رسوم الانضمام {joiningFee}',
      one: 'عن الشهر الأول + رسوم الانضمام {joiningFee}',
      two: 'عن أول {discountPeriod} شهر لك + رسوم الانضمام {joiningFee}',
      few: 'عن أول {discountPeriod} شهر لك + رسوم الانضمام {joiningFee}',
      many: 'عن أول {discountPeriod} شهر لك + رسوم الانضمام {joiningFee}',
      other: 'عن أول {discountPeriod} شهر لك + رسوم الانضمام {joiningFee}'
    },
    iconMoreInfoText: 'معلومات أكثر',
    iconIncludedText: 'مشمول',
    iconExcludedText: 'غير مشمول',
    gymAccess: {
      zero: 'الدخول إلى نادي واحد آخر',
      one: 'الدخول إلى صالة ألعاب رياضية أخرى',
      two: 'الدخول إلى 2 صالات رياضية أخرى',
      few: 'الدخول إلى {gyms} صالة رياضية أخرى',
      many: 'الدخول إلى {gyms} صالة رياضية أخرى',
      other: 'الدخول إلى {gyms} صالة رياضية أخرى'
    },
    gymAccessNoPremium: 'الدخول إلى أندية أخرى',
    bookingDays: {
      zero: 'يوم واحد',
      one: 'يوم 1',
      two: '2 ايام',
      few: '{days} أيام',
      many: '{days} أيام',
      other: '{days} يوم'
    },
    restrictedHours: 'ساعات محدودة',
    restrictedHoursHeading: 'قيود الوقت',
    restrictedHoursWeekday: 'أيام الأسبوع',
    restrictedHoursTimeRanges: 'الأوقات المسموح بها',
    restrictedHoursCloseLabel: 'إغلاق قيود الوقت',
    modalCloseLabel: 'إغلاق شرح مزايا الباقة',
    salesTax: '(زائد ضريبة القيمة المضافة)',
    closestGyms: 'الصالات الرياضية المتوفرة الأقرب لناديك الرئيسي',
    excludedGyms: 'صالات رياضية غير مشمولة',
    includedGyms: {
      zero: '{gymCount} لا تشمل شيء',
      one: '{gymCount} تشمل فرع واحد',
      two: '{gymCount} تشمل فرعين',
      few: '{gymCount} تشمل عدد قليل من الفروع',
      many: '{gymCount} تشمل عدة فروع',
      other: '{gymCount} أخرى'
    },
    packageFeatures: {
      frequencyLabel: 'استخدم الصالة في أي وقت',
      contractLabel: 'بدون عقد ملزم',
      bookingsLabel: 'احجز الكلاس مقدماً',
      buddyLabel: {
        zero: 'احضر صديق {frequency} مرة في الشهر',
        one: 'احضر صديق {frequency} مرة في الشهر',
        two: 'احضر صديق {frequency} مرة في الشهر',
        few: 'احضر صديق {frequency} مرة في الشهر',
        many: 'احضر صديق {frequency} مرة في الشهر',
        other: 'احضر صديق {frequency} مرة في الشهر'
      },
      buddyExplanation: {
        zero: 'يمكن لأعضاء باقة بلس زيارة صالة الألعاب الرياضية الخاصة بهم مع صديق معين بدون تكلفة إضافية {frequency} مرة في الشهر. يمكن للأصدقاء زيارة الصالة  في نفس الوقت مع عضو بلس فقط.',
        one: 'يمكن لأعضاء باقة بلس زيارة صالة الألعاب الرياضية الخاصة بهم مع صديق معين بدون تكلفة إضافية {frequency} مرة في الشهر. يمكن للأصدقاء زيارة الصالة  في نفس الوقت مع عضو بلس فقط.',
        two: 'يمكن لأعضاء باقة بلس زيارة صالة الألعاب الرياضية الخاصة بهم مع صديق معين بدون تكلفة إضافية {frequency} مرة في الشهر. يمكن للأصدقاء زيارة الصالة  في نفس الوقت مع عضو بلس فقط.',
        few: 'يمكن لأعضاء باقة بلس زيارة صالة الألعاب الرياضية الخاصة بهم مع صديق معين بدون تكلفة إضافية {frequency} مرة في الشهر. يمكن للأصدقاء زيارة الصالة  في نفس الوقت مع عضو بلس فقط.',
        many: 'يمكن لأعضاء باقة بلس زيارة صالة الألعاب الرياضية الخاصة بهم مع صديق معين بدون تكلفة إضافية {frequency} مرة في الشهر. يمكن للأصدقاء زيارة الصالة  في نفس الوقت مع عضو بلس فقط.',
        other: 'يمكن لأعضاء باقة بلس زيارة صالة الألعاب الرياضية الخاصة بهم مع صديق معين بدون تكلفة إضافية {frequency} مرة في الشهر. يمكن للأصدقاء زيارة الصالة  في نفس الوقت مع عضو بلس فقط.'
      },
      classesLabel: 'الكلاسات مشمولة في العضوية',
      classesInstructorLabel: 'كلاسات بقيادة مدرب',
      freezeLabel: 'جمد عضويتك في اي وقت',
      freezeExplanation: 'يمكن لأعضاء باقة كور تجميد عضويتهم لمدة تصل إلى 3 أشهر مقابل {freezePrice}. و يمكن لأعضاء باقة بلس تجميد عضويتهم بدون أي تكلفة إضافية لمدة تصل إلى 3 أشهر في فترة 12 شهرًا.',
      massageLabel: 'Recover with a daily massage',
      massageExplanation: 'As a Plus member, you can get access to a daily 10-minute sports massage at no additional cost, on our state-of-the-art massage chairs. The chairs use heated water to apply constant pressure, at a level you can set yourself and working on the whole body or just where you need it most.',
      bodytrackLabel: 'تتبع تقدمك مع فحوصات تكوين الجسم من بوديتراكس',
      bodytrackExplanation: 'يمكن لأعضاء باقة بلس استخدام فحوصات تكوين الجسم من بوديتراكس في الصالة لقياس وزن الجسم ومؤشر الكتلة العضلية و الدهنية في الجسم دون أي تكلفة إضافية.',
      yangaLabel: 'مياه رياضية',
      yangaExplanation: 'حافظ على مستوى السوائل في جسمك مع المزيد من مياه يانغا الرياضية',
      buddyUnlimitedLabel: 'أحضر ضيفًا كذا مرة في الشهر',
      buddyUnlimitedExplanation: 'يمكن لأعضاء باقة بلس زيارة الصالة الخاصة بهم مع صديق معين دون أي تكلفة إضافية مرات غير محدودة في الشهر. يمكن للأصدقاء فقط زيارة صالة الألعاب الرياضية في نفس الوقت مع عضو Plus.',
      freezePlusExplanation: 'يمكن لأعضاء باقة بلس تجميد عضويتهم بدون تكلفة إضافية لمدة تصل إلى 3 أشهر في خلال فترة 12 شهرًا.',
      multiAccessLabel: {
        zero: 'Access to {gymCount} gym',
        one: 'Access to {gymCount} gym',
        two: 'Access to {gymCount} gyms',
        few: 'Access to {gymCount} gyms',
        many: 'Access to {gymCount} gyms',
        other: 'Access to {gymCount} gyms'
      },
      biggerDiscountsLabel: 'خصومات أكبر على العلامات التجارية',
      biggerDiscountsExplanation: 'يمكن لأعضاء بلس الاستمتاع بخصومات حصرية من أفضل العلامات التجارية، بدءًا من الملابس والأطعمة والمزيد في متناول أيديهم. احصل على دخول سريع وسهل إلى جميع الصفقات الحصرية في أي وقت تريده عن طريق تسجيل الدخول إلى منطقة الأعضاء الخاصة بك.',
      classesDigitalLabel: 'الكلاسات مشمولة في العضوية',
      classesGenericLabel: 'الحصص الجماعية المشمولة في العضوية',
      classesInstructorExplanation: 'امكانية المشاركة في حصص جماعية مع مدربينا تحفيزك وتحسين لياقتك، بالإضافة إلى الحصص الرقمية المشمولة في جميع العضويات'
    }
  },
  distance: {
    zero: '{distance} كيلومتر',
    one: '{distance} كيلومتر',
    two: '{distance} كيلومتر',
    few: '{distance} كيلومتر',
    many: '{distance} كيلومتر',
    other: '{distance} كيلومترات'
  }
}
 
export default labels;